import * as signalR from "@microsoft/signalr";
const URL = "/chatHub";
class Connector {
    private connection: signalR.HubConnection;
    public events: (onMessageReceived: (username: string, message: string) => void, onUserListUpdated?: (users: string[]) => void, onMessageHistoryReceived?: (history: any[]) => void) => void;
    static instance: Connector;
    constructor(token: string) {
        this.connection = new signalR.HubConnectionBuilder()
            .withUrl(URL, { accessTokenFactory: () => token })
            .withAutomaticReconnect()
            .build();
        this.connection.start().catch(err => document.write(err));
        this.events = (onMessageReceived, onUserListUpdated, onMessageHistoryReceived) => {
            this.connection.on("ReceiveMessage", (username, message) => {
                onMessageReceived(username, message);
            });
            this.connection.on("UpdateUserList", (users) => {
                if (onUserListUpdated) onUserListUpdated(users);
            });
            this.connection.on("ReceiveMessageHistory", (history) => {
                if (onMessageHistoryReceived) onMessageHistoryReceived(history);
            });
        };
    }

    public newMessage = (user: string, message: string) => {
        this.connection.send("SendMessage", user, message).then(x => console.log("sent"))
    }
    public static getInstance(token: string): Connector {
        if (!Connector.instance)
            Connector.instance = new Connector(token);
        return Connector.instance;
    }
}
export default Connector.getInstance;